export interface GlobalState {
    bannerItems: Array<any>;
}

export const initialState: GlobalState = {
    bannerItems: [],
}